<template>
  <div class="box">
    <HeaderBar title="二维码" :leftArrow="true" routeName='/Home'></HeaderBar>
    <vue-qr :bgSrc='config.imagePath' :logoSrc="config.imagePath" text="http://192.168.3.158:8080/scanningSuccess" :colorDark="config.BYTE_POS" :size="300" class="code"></vue-qr>
  </div>
</template>
<script>
import VueQr from 'vue-qr'
export default {
  data() {
    return {
      config: {
        value: 'www.baidu.com',//显示的值、跳转的地址
        imagePath: require('../../assets/image/bg.jpg'),//中间logo的地址
        BYTE_POS: 'green'
      },

        // pushUrl:'192.168.3.158:' + window.location.port + '/scanningSuccess'
    }
  },
  components: {
    VueQr
  },
  methods:{

  },
  mounted(){
    //  console.log(this.pushUrl);

  }
}
</script>
<style scoped>
.box{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
}
.box .code{
    width: 300px;
    height: 300px;
}
</style>